import { render } from "./index.vue?vue&type=template&id=fa49aa8a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=fa49aa8a&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=fa49aa8a&lang=scss"
script.render = render
script.__scopeId = "data-v-fa49aa8a"

export default script